import { initReactI18next } from 'react-i18next';

import i18n from 'i18next';

import en from '@/utils/translations/en.json';

const resources = {
  en: { translation: en },
};

// Caution: `i18n` also has a named export `use`. will not be fixed for now
// eslint-disable-next-line import/no-named-as-default-member
i18n.use(initReactI18next).init({
  resources,
  lng: 'en',
  fallbackLng: 'en,',
  returnNull: false,
  keySeparator: ':',

  debug: false,
  interpolation: {
    escapeValue: false, // not needed for react as it escapes by default
  },
});

export default i18n;
